{
  "translatedFrom": "Traduit depuis le {{lang}} — voir l'original",
  "originalShown": "Original ({{lang}}) — voir la traduction",
  "translationPending": "Original ({{lang}}) — traduction en attente",
  "allSourcesRetired": "Toutes les sources retirées",
  "unknown": "Inconnu",
  "sourcesCount_one": "{{count}} source",
  "sourcesCount_many": "{{count}} sources",
  "sourcesCount_other": "{{count}} sources",
  "retiredCount_one": "{{count}} retirée",
  "retiredCount_many": "{{count}} retirées",
  "retiredCount_other": "{{count}} retirées",
  "workflowRetired": "RETIRÉ — plus disponible",
  "interested": "Intéressé",
  "notInterested": "Pas intéressé",
  "visit": "Visite :",
  "address": "Adresse :",
  "comment": "Commentaire :",
  "list": {
    "noAdsTitle": "Aucune annonce disponible",
    "noAdsSubtitle": "Revenez plus tard pour de nouvelles annonces correspondant à vos critères.",
    "count_one": "{{count}} bien trouvé",
    "count_many": "{{count}} biens trouvés",
    "count_other": "{{count}} biens trouvés"
  },
  "map": {
    "notAvailable": "Carte non disponible — l'adresse n'a pas pu être géolocalisée",
    "propertyLocation": "Emplacement du bien"
  },
  "sources": {
    "failedToLoad": "Échec du chargement des sources",
    "failedToUnmerge": "Échec de la séparation de la source",
    "activeSources": "Sources actives",
    "multipleSourcesHint": "Cette annonce a été trouvée sur plusieurs sites. La source principale fournit les détails de l'annonce.",
    "singleSourceHint": "Source actuelle de cette annonce.",
    "retiredSources": "Sources retirées",
    "retiredHint": "Ces sources ne sont plus disponibles sur leurs sites respectifs.",
    "primary": "Principale",
    "primaryForced": "Forcée",
    "priceDiffers": "Prix différent",
    "view": "Voir",
    "retiredDetail": "Retirée : {{retiredDate}} | Importée : {{importDate}}",
    "activeDetail": "Vue pour la dernière fois : {{lastSeenDate}} | Importée : {{importDate}}",
    "unmergeTooltip": "Séparer cette source dans une annonce distincte",
    "unmergeDialogTitle": "Séparer la source ?",
    "unmergeDialogBody": "Cette action séparera la source de {{website}} dans une annonce distincte. L'annonce d'origine conservera ses autres sources.",
    "unmerge": "Séparer",
    "setPrimaryTooltip": "Définir comme source principale",
    "resetToAutomaticTooltip": "Revenir à la source principale automatique",
    "failedToSetPrimary": "Échec de la définition de la source principale",
    "failedToResetPrimary": "Échec de la réinitialisation de la source principale"
  },
  "mortgage": {
    "title": "Simulation hypothécaire",
    "resetToDefaults": "Réinitialiser",
    "noPriceError": "L'annonce n'a pas de prix permettant de simuler une hypothèque",
    "recalculateError": "Échec du recalcul de l'hypothèque",
    "resetError": "Échec de la réinitialisation de la simulation hypothécaire",
    "page": {
      "title": "Simulateur hypothécaire",
      "loadError": "Échec du chargement de la simulation hypothécaire"
    },
    "warnings": {
      "INSUFFICIENT_EQUITY": "Fonds propres insuffisants : l'apport personnel est inférieur à la part minimale recommandée du prix d'achat.",
      "DOWN_PAYMENT_COVERS_PRICE": "L'apport couvre l'intégralité du prix d'achat — aucun prêt n'est nécessaire.",
      "EFFORT_RATIO_EXCEEDED": "Le taux d'effort dépasse la part maximale recommandée du revenu du ménage."
    },
    "fields": {
      "price": "Prix d'achat (CHF)",
      "down_payment": "Apport personnel (CHF)",
      "interest_rate": "Taux d'intérêt (%)",
      "term_years": "Durée fixe (années)",
      "maintenance_rate": "Entretien et charges (%)",
      "purchase_costs_rate": "Frais d'acquisition (%)",
      "amortization_target_ltv": "LTV cible d'amortissement (%)",
      "amortization_years": "Durée d'amortissement (années)",
      "stress_test_rate": "Taux de test de résistance (%)",
      "max_effort_ratio": "Taux d'effort maximum (%)",
      "annual_income": "Revenu annuel du ménage (CHF)"
    },
    "downPayment": {
      "title": "Apport personnel",
      "percentLabel": "Part du prix (%)",
      "helper": "Min {{minPercent}} = {{minAmount}} · Max {{maxAmount}}",
      "sliderAria": "Ajuster le montant avec le curseur"
    },
    "results": {
      "loan_amount": "Montant du prêt",
      "ltv": "Ratio prêt/valeur (LTV)",
      "total_cash_needed": "Liquidités totales nécessaires",
      "annual_interest": "Intérêts annuels",
      "annual_amortization": "Amortissement annuel",
      "annual_maintenance": "Entretien annuel",
      "annual_cost": "Coût annuel",
      "monthly_cost": "Coût mensuel",
      "theoretical_annual_cost": "Coût annuel théorique (test de résistance)",
      "required_income": "Revenu annuel requis",
      "effort_ratio": "Taux d'effort",
      "total_interest_over_term": "Intérêts totaux sur la durée fixe"
    },
    "charts": {
      "fundingTitle": "Structure de financement",
      "monthlyTitle": "Répartition du coût mensuel",
      "effortTitle": "Jauge du taux d'effort",
      "segments": {
        "downPayment": "Apport personnel",
        "loanAmount": "Montant du prêt",
        "purchaseCosts": "Frais d'acquisition",
        "interest": "Intérêts",
        "amortization": "Amortissement",
        "maintenance": "Entretien"
      },
      "includePurchaseCosts": "Inclure les frais d'acquisition",
      "titleWithTotal": "{{title}} ({{total}})",
      "amortizationNote": "L'amortissement constitue du capital dans le bien plutôt qu'un coût pur.",
      "effortNote": "Basé sur le coût théorique du test de résistance, et non sur le coût mensuel réel ci-dessus.",
      "maxEffortMarker": "Maximum recommandé : {{value}}"
    }
  },
  "page": {
    "title": "Annonces immobilières",
    "subtitle": "Parcourez et gérez les annonces immobilières correspondant à vos critères",
    "criteriaSet": "Jeu de critères",
    "allCriteriaUnion": "Tous les critères (union)",
    "loadingAds": "Chargement des annonces...",
    "failedToLoadTitle": "Échec du chargement des annonces",
    "untitled": "Sans titre",
    "noAdsInStage": "Aucune annonce à cette étape pour le moment.",
    "retiredTab": "Retiré",
    "scheduleVisit": "Planifier une visite",
    "discard": "Écarter",
    "markVisited": "Marquer comme visité",
    "markBought": "Marquer comme acheté",
    "markAsVisitedTitle": "Marquer comme visité",
    "markAsVisitedDescription": "Veuillez indiquer vos commentaires sur la visite.",
    "discardAdTitle": "Écarter l'annonce",
    "discardAdDescription": "Veuillez indiquer la raison pour laquelle vous écartez cette annonce.",
    "markAsBoughtTitle": "Marquer comme acheté",
    "markAsInterestedToBuyTitle": "Marquer comme intéressé pour acheter",
    "confirmBoughtMessage": "Voulez-vous vraiment marquer ce bien comme acheté ?",
    "confirmInterestedToBuyMessage": "Voulez-vous vraiment marquer ce bien comme intéressé pour l'achat ?",
    "notInterestedTitle": "Pas intéressé - Ajouter un commentaire",
    "notInterestedDescription": "Veuillez indiquer pourquoi vous n'êtes pas intéressé par ce bien."
  },
  "detail": {
    "moveToRetired": "Passer en retiré",
    "allSourcesRetiredTitle": "Toutes les sources de cette annonce ont été retirées",
    "allSourcesRetiredMessage": "Cette annonce n'est plus disponible sur aucun site. Vous pouvez seulement la passer au statut retiré.",
    "priceMismatchTitle": "Les sources ne sont pas d'accord sur le prix",
    "priceMismatchMessage": "Une ou plusieurs sources secondaires indiquent un prix différent de celui affiché ici. Voir « Toutes les sources » ci-dessous pour les détails.",
    "priceLabel": "Prix",
    "sizeLabel": "Surface",
    "roomsLabel": "Pièces",
    "addressHeading": "Adresse",
    "edited": "Modifiée",
    "editAddress": "Modifier l'adresse",
    "matchingCriteria": "Critères correspondants",
    "description": "Description",
    "additionalDetails": "Détails supplémentaires",
    "floor": "Étage :",
    "yearBuilt": "Année de construction :",
    "propertyType": "Type de bien :",
    "status": "Statut :",
    "visitDate": "Date de visite :",
    "visitAddress": "Adresse de visite :",
    "source": "Source",
    "viewOriginal": "Voir l'original",
    "dates": "Dates",
    "imported": "Importée : {{date}}",
    "comments": "Commentaires",
    "addComment": "Ajouter un commentaire",
    "noComments": "Aucun commentaire pour le moment.",
    "statusHistory": "Historique des statuts",
    "noStatusChanges": "Aucun changement de statut pour le moment.",
    "addressUpdated": "Adresse mise à jour",
    "addressUpdateFailed": "Échec de la mise à jour de l'adresse",
    "flaggedInterested": "Annonce marquée comme intéressante !",
    "flagFailed": "Échec du marquage de l'annonce",
    "flaggedNotInterested": "Annonce marquée comme non intéressante",
    "statusUpdated": "Statut mis à jour !",
    "actionFailed": "Échec de l'action",
    "commentAdded": "Commentaire ajouté !",
    "commentAddFailed": "Échec de l'ajout du commentaire",
    "markAsVisitedDescription": "Ajoutez un commentaire sur la visite.",
    "addCommentDialogDescription": "Ajoutez un commentaire au suivi de ce bien.",
    "statusComment": "Commentaire :",
    "editVisitDate": "Modifier la date de visite",
    "editVisitAddress": "Modifier l'adresse de visite",
    "editStatusComment": "Modifier le commentaire",
    "addVisitDate": "Ajouter une date de visite",
    "addVisitAddress": "Ajouter une adresse de visite",
    "addStatusComment": "Ajouter un commentaire de statut",
    "visitDateUpdated": "Date de visite mise à jour",
    "visitDateUpdateFailed": "Échec de la mise à jour de la date de visite",
    "visitAddressUpdated": "Adresse de visite mise à jour",
    "visitAddressUpdateFailed": "Échec de la mise à jour de l'adresse de visite",
    "statusCommentUpdated": "Commentaire mis à jour",
    "statusCommentUpdateFailed": "Échec de la mise à jour du commentaire",
    "editedBy": "Modifié par {{user}}, {{time}}",
    "fieldChanges": "Modifications de champs",
    "noFieldChanges": "Aucune modification de champ pour le moment.",
    "fieldChangeValue": "{{oldValue}} → {{newValue}}",
    "fieldChangeEmpty": "(vide)",
    "fieldNames": {
      "address": "Adresse",
      "visit_date": "Date de visite",
      "visit_address": "Adresse de visite",
      "status_comment": "Commentaire",
      "primary_source": "Source principale"
    },
    "deleteAd": "Supprimer",
    "deleteAdTitle": "Supprimer cette annonce ?",
    "deleteAdMessage": "« {{title}} » et tout ce qui y est lié (sources, statut, commentaires, historique) sera supprimé définitivement. Si l'annonce est toujours en ligne, le robot pourra la réimporter lors de sa prochaine exécution.",
    "adDeleted": "Annonce supprimée",
    "deleteFailed": "Échec de la suppression de l'annonce"
  }
}
